import { UserApi } from 'api/UserApi';
import { backendApiClient } from 'container/backendApiClient';

export const userApi = new UserApi(backendApiClient);
